import {SvgIcon} from "@material-ui/core";

export const CustomSexIcon = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path d="M7.5 10.5C9.57107 10.5 11.25 8.82107 11.25 6.75C11.25 4.67893 9.57107 3 7.5 3C5.42893 3 3.75 4.67893 3.75 6.75C3.75 8.82107 5.42893 10.5 7.5 10.5Z" stroke="#757575" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M7.5 10.5V14.5" stroke="#757575" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M5.5 12.75H9.5" stroke="#757575" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M10.5 1.5H13V4" stroke="#757575" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M10.2737 4.2263L13 1.5" stroke="#757575" strokeLinecap="round" strokeLinejoin="round"/>
        </SvgIcon>
    )
}
